import styled from "styled-components";

export const LinkButton = styled.a`
  border-radius: 3px;
  border: solid 1px #dadde0;
  background-color: #ffffff;
  padding: 11px 17px;
  cursor: pointer;
  text-decoration: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  &:hover {
    text-decoration: none;
  }
`;

export const Image = styled.img`
  margin-right: 12px;
  width: 20px;
`;

export const Text = styled.p`
  letter-spacing: 0.3px;
  color: #494563;
  user-select: none;
  font-weight: 600;
  margin: 0;
  &:hover {
    text-decoration: none;
  }
`;
